export class SearchParameters {
  firstName: string;
  lastName: string;
  birthdate: string;
  credential: string;
  city: string;
  state: string;
  clear: string;
}
